export default __webpack_public_path__ + "static/media/press-07.69f10259.jpg";